import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { isDevMode, NgModule } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatMenuModule } from '@angular/material/menu';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ServiceWorkerModule } from '@angular/service-worker';
import { EntityDataModule } from '@ngrx/data';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AccessControlUtilsModule } from '@p2p/access-control/utils';
import { AuthApiModule } from '@p2p/auth/api';
import { I18nModule } from '@p2p/i18n';
import { NotificationsApiModule } from '@p2p/notifications/api';
import { PaymentFeatureSwitchingModule } from '@p2p/payment/feature-switching';
import { SharedProgressOverlayModule } from '@p2p/shared/progress-overlay';
import { SharedSvgIconModule } from '@p2p/shared/svg-icon';
import { provideEnvironmentNgxMask } from 'ngx-mask';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppI18nModule } from './app.i18n.module';
import { BackdropComponent } from './components/backdrop/backdrop.component';
import { FallbackRoutingComponent } from './components/fallback-routing/fallback-routing.component';
import { HeaderComponent } from './components/header/header.component';
import { MenuComponent } from './components/menu/menu.component';
import { MenuInfoComponent } from './components/menu-info/menu-info.component';
import { authTokenInterceptor } from './interceptors/token.interceptor';

const NGRX = [
    StoreModule.forRoot(
        {},
        {
            metaReducers: isDevMode() ? [] : [],
            runtimeChecks: { strictStateImmutability: true, strictActionImmutability: true }
        }
    ),
    EffectsModule.forRoot([]),
    EntityDataModule.forRoot({})
];
isDevMode() ? NGRX.push(StoreDevtoolsModule.instrument({ connectInZone: true })) : null;

const MAT = [MatMenuModule, MatBadgeModule];

@NgModule({
    imports: [
        BrowserModule,
        I18nModule.forRoot(),
        AppI18nModule,
        AppRoutingModule,
        AuthApiModule,
        NotificationsApiModule,
        ...NGRX,
        ...MAT,
        SharedSvgIconModule,
        AccessControlUtilsModule,
        SharedProgressOverlayModule,
        PaymentFeatureSwitchingModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: !isDevMode(),
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
        })
    ],
    declarations: [
        AppComponent,
        BackdropComponent,
        MenuComponent,
        HeaderComponent,
        FallbackRoutingComponent,
        MenuInfoComponent
    ],
    providers: [
        provideAnimationsAsync(),
        provideHttpClient(withInterceptors([authTokenInterceptor])),
        provideEnvironmentNgxMask({ decimalMarker: '.', thousandSeparator: '' })
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
